import { render, staticRenderFns } from "./NotificationAlert.vue?vue&type=template&id=0fefd8dc&scoped=true&"
import script from "./NotificationAlert.vue?vue&type=script&lang=js&"
export * from "./NotificationAlert.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAlert.vue?vue&type=style&index=0&id=0fefd8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefd8dc",
  null
  
)

export default component.exports